var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { explorers } from '../../types/executor';
export var getTxnResults = function (swapResult) {
    try {
        var addExplorerUrl = function (input) {
            console.log('infwekfput', input);
            return input === null || input === void 0 ? void 0 : input.map(function (x) {
                if (Array.isArray(x)) {
                    //Jito Solana
                    return x
                        .map(function (y) {
                        var network = y === null || y === void 0 ? void 0 : y.network;
                        var hash = y === null || y === void 0 ? void 0 : y.hash;
                        if (!y || !network || !hash)
                            return null;
                        return __assign(__assign({}, y), { explorerUrl: "".concat(explorers[network]).concat(hash) });
                    })
                        .filter(function (x) { return x; });
                }
                else {
                    //Normal
                    var network = x === null || x === void 0 ? void 0 : x.network;
                    var hash = x === null || x === void 0 ? void 0 : x.hash;
                    if (!x || !network || !hash)
                        return null;
                    return __assign(__assign({}, x), { explorerUrl: "".concat(explorers[network]).concat(hash) });
                }
            }).filter(function (x) { return x; });
        };
        var decodedResponse = swapResult === null || swapResult === void 0 ? void 0 : swapResult.decodedResponse;
        //@ts-ignore
        var inputSponsors = addExplorerUrl(
        //@ts-ignore
        (decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sponsorTransactions)
            ? Array.isArray(decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sponsorTransactions)
                ? decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sponsorTransactions
                : [decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sponsorTransactions]
            : //@ts-ignore
                [decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sponsorTransaction].filter(function (x) { return x; }));
        //@ts-ignore
        var inputApprovals = addExplorerUrl(
        //@ts-ignore
        decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.approvalTransactions);
        var inputSwaps = addExplorerUrl(
        //@ts-ignore
        (decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sourceEVMTransactions) ||
            (
            //@ts-ignore
            decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sourceSolanaTransactions) ||
            //@ts-ignore
            ((decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.solanaSwapTransaction)
                ? //@ts-ignore
                    [decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.solanaSwapTransaction]
                : false) ||
            (
            //@ts-ignore
            decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.swapTransactions) || [decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.swapTransaction]);
        var outputSwaps = addExplorerUrl(
        //@ts-ignore
        (decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.destinationEVMTransactions) ||
            (
            //@ts-ignore
            decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.crossChainOutputSwapTransactions) ||
            (
            //@ts-ignore
            decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.destinationSolanaTransactions));
        //@ts-ignore
        console.log('lsgowrhg', inputSponsors, inputApprovals, inputSwaps, outputSwaps, decodedResponse, 
        //@ts-ignore
        (decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sourceEVMTransactions) ||
            (
            //@ts-ignore
            decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sourceSolanaTransactions) ||
            //@ts-ignore
            ((decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.solanaSwapTransaction)
                ? //@ts-ignore
                    [decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.solanaSwapTransaction]
                : false) ||
            (
            //@ts-ignore
            decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.swapTransactions) || [decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.swapTransaction]);
        //@ts-ignore
        return { inputSponsors: inputSponsors, inputApprovals: inputApprovals, inputSwaps: inputSwaps, outputSwaps: outputSwaps };
    }
    catch (e) {
        console.log('getTxnResultsError', e);
        return {
            inputSponsors: [],
            inputApprovals: [],
            inputSwaps: [],
            outputSwaps: [],
        };
    }
};
